import { Column as BaseColumn, IdType } from 'react-table';

import { Column } from './types';

const recursiveRemapColumns = <D extends Record<string, unknown>>(
  columns: Column<D>[]
): BaseColumn<D>[] =>
  columns.map(({ renderHeader, renderCell, renderFooter, ...col }) => ({
    ...col,
    accessor: col.accessor as IdType<D>,
    ...(renderHeader ? { Header: renderHeader } : {}),
    ...(renderCell ? { Cell: renderCell } : {}),
    ...(renderFooter ? { Footer: renderFooter } : {}),
    ...(col.columns
      ? { columns: recursiveRemapColumns(col.columns as Column<D>[]) }
      : {}),
  }));

export default recursiveRemapColumns;
